// @flow
import React from 'react';
import {BottomSheetModal} from '@homeaway/react-modal';
import Tooltip from '@homeaway/react-tooltip';
import {ButtonLink} from '@homeaway/react-buttons';
import {FormattedMessage} from 'react-intl';
import './DualPriceTooltip.less';

import type {Props} from './DualPriceTooltipContainer';

const DualPriceTooltip = ({
    isDesktop,
    content,
    children,
    isOpen,
    openPriceLabelModal,
    closePriceLabelModal
}: Props) => {
    if (isDesktop) {
        return (
            <Tooltip
                tooltipType="popover"
                placement="bottom"
                content={content}
                centered
                wrapperClassName="DualPriceTooltip"
            >
                {children}
            </Tooltip>
        );
    }

    const title = (
        <FormattedMessage
            id={'propertyTotalPrice'}
            description={'Total price'}
            defaultMessage={'View details for price'}
        />
    );

    return (
        <div className="DualPriceTooltip">
            <ButtonLink onClick={openPriceLabelModal} label={children} />
            <BottomSheetModal
                id="DualPriceTooltip"
                isOpen={isOpen}
                onClose={closePriceLabelModal}
                title={title}
            >
                {content}
            </BottomSheetModal>
        </div>
    );
};

export default DualPriceTooltip;
